import { 
  Home, BookOpen, BookText, FileText, 
  FileSpreadsheet, MessageSquare,
  Users, Building, Calendar, Settings
} from 'lucide-react';

// Navigation principale - Flux comptable
export const navigation = [
  { 
    name: 'Tableau de Bord', 
    icon: Home, 
    path: '/',
    badge: null
  },
  { 
    name: 'Journaux', 
    icon: BookOpen, 
    path: '/journals',
    badge: null
  },
  { 
    name: 'Grand Livre', 
    icon: BookText, 
    path: '/ledger',
    badge: null
  },
  { 
    name: 'États Financiers', 
    icon: FileText, 
    path: '/reports',
    badge: null
  },
  { 
    name: 'Déclarations', 
    icon: FileSpreadsheet, 
    path: '/declarations',
    badge: null
  },
] as const;

// Navigation secondaire - Gestion
export const secondaryNavigation = [
  { 
    name: 'Exercices', 
    icon: Calendar, 
    path: '/fiscal-years'
  },
  { 
    name: 'Entreprise', 
    icon: Building, 
    path: '/organization'
  },
  { 
    name: 'Utilisateurs', 
    icon: Users, 
    path: '/users'
  },
  { 
    name: 'Paramètres', 
    icon: Settings, 
    path: '/settings'
  },
] as const;

// Assistant IA
export const assistantNavigation = [
  { 
    name: 'Assistant Compta', 
    icon: MessageSquare, 
    path: '/chat',
    badge: { text: 'IA', color: 'bg-purple-500' }
  },
] as const;